'use strict';

import * as angular from 'angular'; 

var analysisVuTpl = require('../analysis/vu/vu.html');
var analysisCoverageMapTpl = require('../analysis/coverage-map/coverage-map.html');
var analysisChartTpl = require('../analysis/chart/chart.html');
var analysisBaseTpl = require('../analysis/base/base.html');
var baseErrorTpl = require('../base/error.html');
var baseAnalysisControllerPeriodResolve = require('../analysis/base/baseAnalysisController.period.resolve');
var baseAnalysisControllerTripResolve = require('../analysis/base/baseAnalysisController.trip.resolve');
var slaTrendAnalysisTrendTpl = require('../sla-trend-analysis/trend.html');
var tripTrendControllerResolve = require('../sla-trend-analysis/tripTrendController.resolve');

import uiRouter from '@uirouter/angularjs';
import "@uirouter/angularjs/release/stateEvents";

var app = angular.module('noc.routes', [ uiRouter, 'ui.router.upgrade', 'ui.router.state.events', 'oc.lazyLoad']);

app.config(["$urlRouterProvider", "$stateProvider", "$ocLazyLoadProvider", '$locationProvider',
 function($urlRouterProvider, $stateProvider, $ocLazyLoadProvider, $locationProvider) {

    $locationProvider.hashPrefix('');
    $urlRouterProvider.otherwise('/error/404');
    $urlRouterProvider.when('', ['$state', '$match', function ($state, $match) {
        $state.go('index');
    }]);

    $ocLazyLoadProvider.config({
        events: true,
    });

    $stateProvider
        .state('error', {
            title: 'Error',
            url: '/error/:error',
            template: baseErrorTpl,
            controller: 'ErrorPageController as error'
        })
        .state('trend', {
            title: 'Trend',
            url: '/trip/trend/project/:projectId',
            template: slaTrendAnalysisTrendTpl,
            controller: 'TripTrendController',
            resolve: Object.assign({}, tripTrendControllerResolve, {
                lazyLoadTrainConfig: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../sla-trend-analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.slaTrendAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            })
        })
        .state('trip', {
            abstract: true,
            url: '/trip',
            template: '<ui-view/>',
            resolve: {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('period', {
            abstract: true,
            url: '/period',
            template: '<ui-view/>',
            resolve: {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('period.search', {
            title: 'Period Analysis',
            url: '/period-analysis/project/:projectId',
            views: {
                '': {
                    template: analysisBaseTpl,
                    controller: 'BaseAnalysisController as base'
                }
            },
            resolve: Object.assign({}, baseAnalysisControllerPeriodResolve, {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })
        })

        .state('period-analysis', {
            title: 'Period Analysis',
            abstract: true,
            url: '/period-analysis/project/:projectId/train/:trainId?startDate&endDate&filter&minimum&maximum&intervals&reverseColors&logscale&reload&live&follow&intervalTime&templateId&templateConfigName&tab&stacking&interpolate&interpolateSeconds',
            views: {
                '': {
                    template: analysisBaseTpl,
                    controller: 'BaseAnalysisController as base'
                }
            },
            resolve: Object.assign({}, baseAnalysisControllerPeriodResolve, {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })
        })
        .state('period-analysis.chart', {
            title: 'Period Analysis Chart',
            url: '/chart',
            template: analysisChartTpl,
            controller: 'ChartAnalysisController as ch'
        })
        .state('period-analysis.coverage-map', {
            title: 'Period Analysis Coverage Map',
            url: '/coverage-map',
            template: analysisCoverageMapTpl,
            controller: 'CoverageMapAnalysisController as cm'
        })
        .state('period-analysis.vu', {
            title: 'Period Analysis Vu',
            url: '/vu',
            template: analysisVuTpl,
            controller: 'VuAnalysisController as vu'
        })
        .state('trip-analysis', {
            title: 'Trip Analysis',
            url: '/trip-analysis/project/:projectId/trip/:tripId?filter&minimum&maximum&intervals&reverseColors&logscale&reload&templateId&tab&stacking&interpolate&interpolateSeconds',
            template: analysisBaseTpl,
            controller: 'BaseAnalysisController as base',
            abstract: true,
            resolve: Object.assign({}, baseAnalysisControllerTripResolve, {
                lazyLoadTrainSchedule: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('../analysis/index.ts');
                        $ocLazyLoad.load({
                            name: 'noc.analysis'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            })

        })
        .state('trip-analysis.chart', {
            title: 'Trip Analysis Chart',
            url: '/chart',
            template: analysisChartTpl,
            controller: 'ChartAnalysisController as ch'
        })
        .state('trip-analysis.coverage-map', {
            title: 'Trip Analysis Coverage Map',
            url: '/coverage-map',
            template: analysisCoverageMapTpl,
            controller: 'CoverageMapAnalysisController as cm'
        })
        .state('trip-analysis.vu', {
            title: 'Trip Analysis Vu',
            url: '/vu',
            template: analysisVuTpl,
            controller: 'VuAnalysisController as vu'
        })
}]);

export default app;
